export { useControleDeRequisicao } from './controle-de-requisicao.hook'
export * from './controle-de-requisicao.interface'
